export default "__VITE_ASSET__rwLKGhSn__"